// project imports
// import { handlerCustomerDialog } from 'api/customer';
// import { NavActionType } from 'config';

// assets
import BuildOutlined from '@ant-design/icons/BuildOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import LinkOutlined from '@ant-design/icons/LinkOutlined';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  PlusOutlined,
  LinkOutlined
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
  id: 'group-applications',
  title: 'applications',
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  children: [
    // {
    //   id: 'chat',
    //   title: 'chat',
    //   type: 'item',
    //   url: '/apps/chat',
    //   icon: icons.MessageOutlined,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'calendar',
    //   title: 'calendar',
    //   type: 'item',
    //   url: '/apps/calendar',
    //   icon: icons.CalendarOutlined,
    //   actions: [
    //     {
    //       type: NavActionType.LINK,
    //       label: 'Full Calendar',
    //       icon: icons.LinkOutlined,
    //       url: 'https://fullcalendar.io/docs/react',
    //       target: true
    //     }
    //   ]
    // },
    // {
    //   id: 'kanban',
    //   title: 'kanban',
    //   type: 'item',
    //   icon: BuildOutlined,
    //   link: '/apps/kanban/:tab',
    //   url: '/apps/kanban/board',
    //   breadcrumbs: false
    // },
    {
      id: 'quote',
      title: 'quotes',
      url: '/apps/quote/dashboard',
      type: 'collapse',
      icon: icons.FileTextOutlined,
      breadcrumbs: false,
      children: [
        {
          id: 'quote-create',
          title: 'create',
          type: 'item',
          url: '/apps/quote/create',
          breadcrumbs: false
        },
        {
          id: 'quote-list',
          title: 'list',
          type: 'item',
          url: '/apps/quote/list',
          breadcrumbs: false
        },
        {
          id: 'quote-details',
          title: 'details',
          type: 'item',
          link: '/apps/quote/details/:id',
          url: '/apps/quote/details/1',
          breadcrumbs: false,
          hidden: true
        },
        {
          id: 'quote-edit',
          title: 'edit',
          type: 'item',
          link: '/apps/quote/edit/:id',
          url: '/apps/quote/edit/1',
          breadcrumbs: false,
          hidden: true
        }
      ]
    },
    {
      id: 'client',
      title: 'clients',
      type: 'item',
      icon: icons.CustomerServiceOutlined,
      url: '/apps/client/list',
      breadcrumbs: false
      // children: [
      //   {
      //     id: 'customer-list',
      //     title: 'list',
      //     type: 'item',
      //     url: '/apps/customer/customer-list',
      //     actions: [
      //       {
      //         type: NavActionType.FUNCTION,
      //         label: 'Add Customer',
      //         function: () => handlerCustomerDialog(true),
      //         icon: icons.PlusOutlined
      //       }
      //     ]
      //   },
      //   {
      //     id: 'customer-card',
      //     title: 'cards',
      //     type: 'item',
      //     url: '/apps/customer/customer-card'
      //   }
      // ]
    },
    {
      id: 'item',
      title: 'items',
      type: 'item',
      icon: icons.AppstoreAddOutlined,
      url: '/apps/item/list',
      breadcrumbs: false
      // children: [
      //   {
      //     id: 'customer-list',
      //     title: 'list',
      //     type: 'item',
      //     url: '/apps/customer/customer-list',
      //     actions: [
      //       {
      //         type: NavActionType.FUNCTION,
      //         label: 'Add Customer',
      //         function: () => handlerCustomerDialog(true),
      //         icon: icons.PlusOutlined
      //       }
      //     ]
      //   },
      //   {
      //     id: 'customer-card',
      //     title: 'cards',
      //     type: 'item',
      //     url: '/apps/customer/customer-card'
      //   }
      // ]
    }
    // {
    //     id: 'customer',
    //     title: 'customer',
    //     type: 'collapse',
    //     icon: icons.CustomerServiceOutlined,
    //     children: [
    //         {
    //             id: 'customer-list',
    //             title: 'list',
    //             type: 'item',
    //             url: '/apps/customer/customer-list',
    //             actions: [
    //                 {
    //                     type: NavActionType.FUNCTION,
    //                     label: 'Add Customer',
    //                     function: () => handlerCustomerDialog(true),
    //                     icon: icons.PlusOutlined
    //                 }
    //             ]
    //         },
    //         {
    //             id: 'customer-card',
    //             title: 'cards',
    //             type: 'item',
    //             url: '/apps/customer/customer-card'
    //         }
    //     ]
    // },
    // {
    //   id: 'invoice',
    //   title: 'invoice',
    //   url: '/apps/invoice/dashboard',
    //   type: 'collapse',
    //   icon: icons.FileTextOutlined,
    //   breadcrumbs: false,
    //   children: [
    //     {
    //       id: 'invoice-create',
    //       title: 'create',
    //       type: 'item',
    //       url: '/apps/invoice/create',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'invoice-details',
    //       title: 'details',
    //       type: 'item',
    //       link: '/apps/invoice/details/:id',
    //       url: '/apps/invoice/details/1',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'invoice-list',
    //       title: 'list',
    //       type: 'item',
    //       url: '/apps/invoice/list',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'invoice-edit',
    //       title: 'edit',
    //       type: 'item',
    //       link: '/apps/invoice/edit/:id',
    //       url: '/apps/invoice/edit/1',
    //       breadcrumbs: false
    //     }
    //   ]
    // },
    // {
    //   id: 'profile',
    //   title: 'profile',
    //   type: 'collapse',
    //   icon: icons.UserOutlined,
    //   children: [
    //     {
    //       id: 'user-profile',
    //       title: 'user-profile',
    //       type: 'item',
    //       link: '/apps/profiles/user/:tab',
    //       url: '/apps/profiles/user/personal',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'account-profile',
    //       title: 'account-profile',
    //       type: 'item',
    //       link: '/apps/profiles/account/:tab',
    //       url: '/apps/profiles/account/basic',
    //       breadcrumbs: false
    //     }
    //   ]
    // },
    // {
    //   id: 'e-commerce',
    //   title: 'e-commerce',
    //   type: 'collapse',
    //   icon: icons.ShoppingCartOutlined,
    //   children: [
    //     {
    //       id: 'products',
    //       title: 'products',
    //       type: 'item',
    //       url: '/apps/e-commerce/products'
    //     },
    //     {
    //       id: 'product-details',
    //       title: 'product-details',
    //       type: 'item',
    //       link: '/apps/e-commerce/product-details/:id',
    //       url: '/apps/e-commerce/product-details/1',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'product-list',
    //       title: 'product-list',
    //       type: 'item',
    //       url: '/apps/e-commerce/product-list'
    //     },
    //     {
    //       id: 'add-new-product',
    //       title: 'add-new-product',
    //       type: 'item',
    //       url: '/apps/e-commerce/add-new-product'
    //     },
    //     {
    //       id: 'checkout',
    //       title: 'checkout',
    //       type: 'item',
    //       url: '/apps/e-commerce/checkout'
    //     }
    //   ]
    // }
  ]
};

export default applications;
